import { action, makeObservable, observable } from 'mobx';

class HelpAndSupportStore {
  helpMenuToggle = false;
  isProfileDetailsActive = false;

  constructor() {
    makeObservable(this, {
      helpMenuToggle: observable,
      setHelpMenuToggle: action,
      isProfileDetailsActive: observable,
      handleChangeActiveProfileDetails: action,
    });
  }

  setHelpMenuToggle = (): void => {
    this.helpMenuToggle = !this.helpMenuToggle;
  };

  handleChangeActiveProfileDetails = (value: boolean): void => {
    this.isProfileDetailsActive = value;
  };
}
export const helpAndSupportStore = new HelpAndSupportStore();
